/**
 * HOW TO:
 *  1. Create a new file env.js
 *  2. Copy contents of this file (env.example.js) to the new file
 *  2. Replace the constants with variables specific for your environment
 *
 * NOTE:
 *  env.js file should NEVER be uploaded to a version control platform (e.g, git)
 */

// const HOST = 'localhost';

export const HOST = 'baseapi.odebox.net';

export const PROTOCOL = HOST === 'localhost'? 'http': 'https';

export const IMAGE_HOST = "https://baseapi.odebox.net"

export const EDITOR_HOST = HOST === 'localhost'?'http://localhost:7979/#':'https://odeboxpagebuilder-landingpage.odebox.net/#'

export const EDITOR_API = HOST === 'localhost'?'localhost:8010':'baseapi.odebox.net'

export const UIHOST = HOST === 'localhost'? `${HOST}:8080`: `merchants.odebox.com`;

export const BASE_URL = PROTOCOL=='http'?`${PROTOCOL}://${HOST}:8010/api/v1/`: `${PROTOCOL}://${HOST}/api/v1/`;

export const REDIRECT_URI = `${PROTOCOL}://${UIHOST}/#/finalize`;

export const SOCKET_HOST =HOST === 'localhost'? `${PROTOCOL}://${HOST}:8083`:`${PROTOCOL}://${HOST}`;

